import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import NotificationsList from './NotificationsList';
import Page from '../admin/common/Page';
import ManageNotification from './ManageNotification';

const Notifications = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <NotificationsList />
      </Route>
      <Route path={`${path}/new`}>
        <Page title='Add Outage Notification'>
          <ManageNotification />
        </Page>
      </Route>
      <Route path={`${path}/edit/:notificationId`}>
        <Page title='Edit Outage Notifications'>
          <ManageNotification />
        </Page>
      </Route>
    </Switch>
  );
};

export default Notifications;
